import React, { useState } from "react";
import { getEscudoUrl } from "../api/ligaApi";

const TabelaClassificacaoGeral = ({ duplas, rodadasData }) => {
  const [expandedDuplaId, setExpandedDuplaId] = useState(null);

  const handleToggleExpand = (duplaId) => {
    setExpandedDuplaId((prevId) => (prevId === duplaId ? null : duplaId));
  };

  const calcularPontuacaoTotalDupla = (duplaId) => {
    // Encontra todos os times da dupla
    const timesDaDupla =
      duplas.find((d) => d.id === duplaId)?.times.map((t) => t.id.toString()) ||
      [];

    // Soma os pontos de todos os times da dupla
    return rodadasData
      .filter((p) => p.time_id && timesDaDupla.includes(p.time_id.toString()))
      .reduce((acc, curr) => acc + curr.pontos, 0);
  };

  const calcularPontuacaoTotalTime = (timeId) => {
    return rodadasData
      .filter((p) => p.time_id && p.time_id.toString() === timeId.toString())
      .reduce((acc, curr) => acc + curr.pontos, 0);
  };

  const leaderboard = duplas
    .map((dupla) => ({
      ...dupla,
      pontuacaoGeral: calcularPontuacaoTotalDupla(dupla.id),
      times: dupla.times
        .map((time) => ({
          ...time,
          pontuacaoGeral: calcularPontuacaoTotalTime(time.id),
        }))
        .sort((a, b) => b.pontuacaoGeral - a.pontuacaoGeral),
    }))
    .sort((a, b) => b.pontuacaoGeral - a.pontuacaoGeral);

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left">
        <thead className="bg-gray-700/50">
          <tr>
            <th className="p-2 sm:p-3 w-12 text-sm sm:text-base">#</th>
            <th className="p-2 sm:p-3 text-sm sm:text-base">Dupla</th>
            <th className="p-2 sm:p-3 text-right text-sm sm:text-base">
              Pontuação Geral
            </th>
          </tr>
        </thead>
        <tbody>
          {leaderboard.map((dupla, index) => (
            <React.Fragment key={dupla.id}>
              <tr
                className="border-b border-gray-700 hover:bg-gray-700/30 cursor-pointer"
                onClick={() => handleToggleExpand(dupla.id)}
              >
                <td className="p-2 sm:p-3 font-bold">{index + 1}</td>
                <td className="p-2 sm:p-3 flex items-center text-base sm:text-lg font-semibold text-white">
                  <img
                    src={
                      getEscudoUrl(dupla.logo_url) || "/pair-icon.png" // Um logo padrão
                    }
                    alt=""
                    className="w-8 h-8 mr-3 rounded-full object-contain bg-gray-700"
                  />
                  {dupla.nome}
                </td>
                <td className="p-2 sm:p-3 text-right font-bold text-teal-400 text-base sm:text-lg">
                  {dupla.pontuacaoGeral.toFixed(2)}
                </td>
              </tr>
              {expandedDuplaId === dupla.id && (
                <tr className="bg-gray-900/50">
                  <td colSpan="3" className="p-0">
                    <div className="p-2 sm:p-4 sm:pl-12">
                      <h4 className="text-sm font-semibold text-gray-400 mb-2">
                        Detalhes da Dupla (Pontuação Acumulada)
                      </h4>
                      <div className="space-y-2">
                        {dupla.times
                          .sort((a, b) =>
                            a.nome_time.localeCompare(b.nome_time)
                          )
                          .map((time) => (
                            <div
                              key={time.id}
                              className="flex justify-between items-center bg-gray-800/50 p-2 rounded"
                            >
                              <div className="flex items-center">
                                <img
                                  src={getEscudoUrl(time.escudo_url)}
                                  alt={`Escudo do ${time.nome_time}`}
                                  className="w-6 h-6 rounded-full mr-3"
                                />
                                <div>
                                  <p className="font-semibold text-sm flex items-center text-white">
                                    {time.nome_time}
                                    {time.is_captain && (
                                      <span className="ml-2 text-yellow-400 font-bold text-xs">
                                        (C)
                                      </span>
                                    )}
                                  </p>
                                  <p className="text-xs text-gray-500">
                                    {time.nome_cartoleiro}
                                  </p>
                                </div>
                              </div>
                              <p className="font-semibold text-teal-500 text-sm">
                                {time.pontuacaoGeral.toFixed(2)} pts
                              </p>
                            </div>
                          ))}
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TabelaClassificacaoGeral;
